import {
    IStepUser,
    JobApplicationStatusUpdateValues,
} from '../../../../common';
import { Icon, useTheme } from '../../../../base';
import { StepIconRoot } from './CustomStepIcon.styles';

interface Props {
    status: JobApplicationStatusUpdateValues | undefined;
    users: Array<IStepUser>;
}

const CustomStepIcon = (props: Props) => {
    const { status } = props;
    const theme = useTheme();
    return (
        <>
            <StepIconRoot>
                {status === JobApplicationStatusUpdateValues.accept && (
                    <Icon name={'CheckRoundedIcon'} size={24} />
                )}
                {status === JobApplicationStatusUpdateValues.reject && (
                    <Icon name={'CloseRoundedIcon'} size={24} />
                )}
                {status === JobApplicationStatusUpdateValues.inProcess && (
                    <div
                        style={{
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            backgroundColor: theme.palette.secondary.main,
                        }}
                    />
                )}
            </StepIconRoot>
        </>
    );
};

export default CustomStepIcon;
